export type PropsWithDataAttributes<T> = T & {
    dataAttributes?: Record<string, string>;
};

export function renderDataAttributes(dataAttributes?: Record<string, string>) {
    if (!dataAttributes) {
        return {};
    }

    return Object.entries(dataAttributes).reduce<Record<string, string>>((attrs, [ key, value ]) => {
        attrs[`data-${key}`] = value;
        return attrs;
    }, {});
}
